export const convertStatus = status => {
    let convertedStatus = {label: status, color: '#303030'};
    if (status === 'waiting-exclusive-valuation') {
      convertedStatus = {label: 'Menunggu Diproses', color: '#E79212'};
    } else if (status === 'draft-exclusive') {
      convertedStatus = {label: 'Draft', color: '#303030'};
    } 
    return convertedStatus;
  };
  